import { createContext, useContext } from "react"
import type { AppColorMode } from "../components/theme"

export const COLOR_MODE_KEY = "colorMode"

export interface ColorModeContextValue {
  mode: AppColorMode
  toggle: () => void
  /** Aplica o tema salvo no backend: 0 = claro, 1 = escuro, null = padrão do sistema. */
  applyUserTheme: (raw: number | null | undefined) => void
}

export const ColorModeContext = createContext<ColorModeContextValue>({
  mode: "light",
  toggle: () => {},
  applyUserTheme: () => {},
})

export const useColorMode = () => useContext(ColorModeContext)
